module.exports = __webpack_public_path__ + "img/icon-add-device.429e9335.svg";